const category = {
  state: {
    category_data: null
  },
  mutations: {
    setCategory(state, data) {
      state.category_data = data;
    }
  }
};
export default category;



// WEBPACK FOOTER //
// ./src/stroe/modules/category.js